/**
 * Form configuration data
 * Defines form fields for authentication pages
 */

export interface FormField {
  id: string;
  label: string;
  type: string;
  placeholder: string;
}

const loginFormData: FormField[] = [
  {
    id: 'email',
    label: 'Email',
    type: 'email',
    placeholder: 'Enter your email'
  },
  {
    id: 'password',
    label: 'Password',
    type: 'password',
    placeholder: 'Enter your password'
  }
];

const createAccountFormData: FormField[] = [
  {
    id: 'email',
    label: 'Email',
    type: 'email',
    placeholder: 'Enter your email'
  },
  {
    id: 'password',
    label: 'Password',
    type: 'password',
    placeholder: 'Create a password'
  },
  {
    id: 'confirmPassword',
    label: 'Confirm Password',
    type: 'password',
    placeholder: 'Confirm your password'
  }
];

const formConfig = {
  loginFormData,
  createAccountFormData
};

export default formConfig;
